import { useStyles } from './styles'
import { TourTextProps } from '../tour.typings'
import TourTooltip from '../tourTooltip/tourTooltip'
import React, { memo, ReactNode, useCallback } from 'react'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { closeTour, gotoNextStep, gotoPreviousStep } from '../../../reducer/tour.reducer'
import { selectCurrentStep, selectTourSteps } from '../../../selectors/tour'

const TourTexts: React.FC<TourTextProps> = ({ elements }) => {
    const dispatch = useDispatch()
    const { classes } = useStyles()
    const steps = useSelector(selectTourSteps)
    const currentStepNumber = useSelector(selectCurrentStep)
    const onNextClick = useCallback(() => {
        if (currentStepNumber === steps.length - 1) {
            dispatch(closeTour())
            return
        }
        dispatch(gotoNextStep())
    }, [currentStepNumber])
    const onPreviousClick = useCallback(() => dispatch(gotoPreviousStep()), [])
    const onSkipClick = useCallback(() => dispatch(closeTour()), [])

    return <>{elements.map((ele, i) => {
        const { coordinates: { topLeft, topRight, bottomLeft }, textPosition, text } = ele
        const width = topRight.x - topLeft.x
        const height = bottomLeft.y - topLeft.y

        const html: ReactNode = (
            <>
                <div dangerouslySetInnerHTML={{ __html: text }} className={classes.tooltipContent}></div>
                <div className={classes.tooltipBottomBar}>
                    <Button onClick={onSkipClick} className={classes.skipButton} variant="text" disableFocusRipple
                            disableTouchRipple color="inherit">Skip</Button>
                    <div className={classes.actionButtonsContainer}>
                        {currentStepNumber > 0 &&
                            <Button onClick={onPreviousClick} className={classes.actionButton} variant="text"
                                    disableFocusRipple disableTouchRipple color="inherit">Back</Button>}
                        <Button onClick={onNextClick} className={classes.actionButton} disableElevation
                                variant="contained">{currentStepNumber === steps.length - 1 ? 'Finish' : 'Next'}</Button>
                    </div>
                </div>
            </>
        )
        return (
            <TourTooltip key={ele.selector ? `${ele.selector}-${i}` : i} placement={textPosition} title={html}>
                <div className={classes.anchor} style={{
                    left: topLeft.x,
                    top: topLeft.y,
                    width: `${width}px`,
                    height: `${height}px`
                }}></div>
            </TourTooltip>
        )
    })}</>
}

export default memo(TourTexts)